import { render, staticRenderFns } from "./ReviewMenu.vue?vue&type=template&id=4ad4f618&"
import script from "./ReviewMenu.vue?vue&type=script&lang=js&"
export * from "./ReviewMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReviewMenu.vue"
export default component.exports